import wallet from './wallet';

export default {
    WALLET: wallet,
}